<template>
  <div class="content" style="background: #f3f5f9; min-height: 100vh">
    <title-bar :title="$lang.common_txt193"> </title-bar>
    <div class="bet-bg d-flex-s">
      <p
        v-for="(item, index) in [$lang.common_txt194, $lang.common_txt195]"
        :key="index"
        @click="selectType(index)"
        :class="{ 'active-type': selectIndex === index }"
      >
        {{ item }}
      </p>
    </div>
    <div v-if="readFailed && readOnlyMessage" class="lot-readonly-message">
      {{ readOnlyMessage }}
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      loading-text=" "
      @load="loadMore"
      class="order-list"
    >
      <div class="bet-scroll">
        <div
          class="bet-scroll-i"
          v-for="(item, index) in betList"
          :key="index"
          @click="goToDetil(item)"
        >
          <div class="d-flex-s f-t-15">
            <p>
              <span class="f-w">{{ item.lotteryName }}</span>
              <span>({{ item.issueNo }})</span>
            </p>
            <!-- <p v-html="item.statusDescr"></p> -->
            <p class="f-w" :style="textStyle(item.statusCode)">
              {{ getStatus(item.statusCode) }}
            </p>
          </div>
          <div class="d-flex-s m-t-15">
            <p>{{ $lang.common_txt196 }}</p>
            <p>{{ formatDate(item.betTime) }}</p>
          </div>
          <div class="d-flex-s m-t-10">
            <p>{{ $lang.common_txt197 }}</p>
            <p class="f-w f-t-15">
              <span>{{ getCurrency }} </span>
              <span style="color: #ed0000"
                >-{{ $formatNumberWithCommas(item.betAmount) }}</span
              >
            </p>
          </div>
          <div class="d-flex-s m-t-10">
            <p>{{ $lang.common_txt198 }}</p>
            <p class="f-w f-t-15">
              <span>{{ getCurrency }} </span>
              <span style="color: #007524"
                >+{{ $formatNumberWithCommas(item.sendAmount) }}</span
              >
            </p>
          </div>
        </div>
      </div>
      <!-- 没有数据时显示 -->
      <div v-if="!betList.length && !loading && !readFailed" class="empt-bg">
        <img src="../../../assets/img/common/img_no_data2.png" width="80%" />
        <p class="f-t-18 f-w">{{ $lang.noempt }}</p>
      </div>
      <!-- <van-empty
          v-if="!betList.length && !loading && !isRefreshing"
          :image="require('../../../assets/img/common/img_no_data2.png')"
          description="No Records"
        /> -->
    </van-list>
  </div>
</template>
<script>
import { GetBetList } from '@/api/common'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import {
  isLotteryNeedLoginResponse,
  isLotteryOkResponse,
  isLotteryReadOnlyQueryResponse,
  isLotteryReadableResponse,
  lotteryResponseBody,
  lotteryResponseMessage
} from './lotteryResponse'

function guardedLocalStorage() {
  try {
    return safeLocalStorage()
  } catch (e) {
    return null
  }
}

function safeJumpTo(vm, ...args) {
  if (vm && typeof vm.$jumpTo === 'function') {
    vm.$jumpTo(...args)
  }
}

export default {
  name: 'BetHistory',
  components: {},
  data() {
    return {
      selectIndex: 0,
      pageIndex: 0,
      betList: [],
      loading: false, // 是否正在加载更多数据
      finished: false, // 是否已经加载完所有数据
      readOnlyQuery: false,
      readFailed: false,
      readOnlyMessage: '',
      pageSize: 20
    }
  },
  mounted() {
    // this.GetBetList()
  },
  methods: {
    firstValue(...values) {
      const hit = values.find((value) => value !== undefined && value !== null && value !== '')
      return hit === undefined ? '' : hit
    },
    responseBody(data) {
      return lotteryResponseBody(data)
    },
    responseErrorPayload(error) {
      if (!error) return error
      if (error.status !== undefined || error.code !== undefined || error.content || error.payload || error.extra || error.page) {
        return error
      }
      return error && (
        (error.response && (error.response.data || error.response.body)) ||
        error.data ||
        error.body ||
        error.content ||
        error
      )
    },
    isOkResponse(data) {
      return isLotteryOkResponse(data)
    },
    pickList(data, keys = []) {
      const body = this.responseBody(data)
      const names = keys.concat(['betList', 'list', 'records', 'dataList', 'orderList', 'items', 'pageList'])
      const search = (source) => {
        if (!source || typeof source !== 'object') return []
        if (Array.isArray(source)) return source
        for (const key of names) {
          if (Array.isArray(source[key])) return source[key]
        }
        for (const key of ['content', 'payload', 'extra', 'page', 'data', 'body']) {
          const list = search(source[key])
          if (list.length) return list
        }
        return []
      }
      return this.safeList(search(body))
    },
    safeList(list) {
      return Array.isArray(list) ? list : []
    },
    safeNumber(value) {
      const num = Number(value)
      return Number.isFinite(num) ? num : 0
    },
    hasLogin() {
      return !!safeGetStorageItem(guardedLocalStorage(), 'token')
    },
    formatDate(value) {
      if (!value) return '--'
      const date = this.$dayjs(value)
      return date && date.isValid && date.isValid()
        ? date.format('DD/MM/YYYY HH:mm:ss')
        : String(value)
    },
    safeToast(options) {
      if (typeof this.$toast === 'function') {
        this.$toast(options)
      }
    },
    showNeedLogin() {
      this.safeToast({
        message: this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now',
        icon: 'fail'
      })
      safeJumpTo(this, '/home', {}, { replace: true })
    },
    showReadBlocked() {
      if (typeof this.$toast === 'function') {
        this.$toast({
          message: this.readOnlyMessage || this.$lang.common_txt376 || this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.',
          icon: 'cross'
        })
      }
    },
    normalizeBet(item = {}) {
      const statusCode = this.firstValue(
        item.statusCode,
        item.orderStatus,
        item.childOrderStatus,
        item.status
      )
      return {
        ...item,
        lotteryName: this.firstValue(item.lotteryName, item.gameName, item.lotteryType, '--'),
        issueNo: this.firstValue(item.issueNo, item.issue_no, '--'),
        statusCode,
        betTime: this.firstValue(item.betTime, item.createDate, item.create_date),
        betAmount: this.safeNumber(item.betAmount || item.amount),
        sendAmount: this.safeNumber(
          this.firstValue(item.sendAmount, item.winAmount, item.bonusAmount)
        ),
        betOrderNo: this.firstValue(item.betOrderNo, item.mainOrderNo, item.orderNo),
        childOrderNo: this.firstValue(item.childOrderNo, item.child_order_no)
      }
    },
    betRecordKey(item) {
      const record = item || {}
      return [
        this.firstValue(record.betOrderNo, record.mainOrderNo, record.orderNo),
        this.firstValue(record.childOrderNo, record.child_order_no),
        this.firstValue(record.betTime, record.createDate, record.create_date),
        this.firstValue(record.betAmount, record.amount),
        this.firstValue(record.statusCode, record.orderStatus, record.status)
      ].map(value => value === undefined || value === null ? '' : String(value)).join('|')
    },
    mergeBetList(list) {
      const seen = new Set(this.betList.map(item => this.betRecordKey(item)).filter(Boolean))
      const next = this.safeList(list).filter(item => {
        const key = this.betRecordKey(item)
        if (!key) return true
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
      this.betList = this.betList.concat(next)
    },
    textStyle(v) {
      if (v === 'bet$no_win') {
        return { color: '#53646B' }
      } else if (v === 'bet$u_cancelled') {
        return { color: '#ED0000' }
      } else if (v === 'bet$won') {
        return { color: '#007524' }
      } else if (v === 'bet$s_cancelled') {
        return { color: '#ED0000' }
      } else if (v === 'bet$draw_waiting') {
        return { color: '#25A09C' }
      }
    },
    getStatus(v) {
      if (v === 'bet$no_win') {
        return this.$lang.common_txt199
      } else if (v === 'bet$u_cancelled') {
        return this.$lang.common_txt200
      } else if (v === 'bet$won') {
        return this.$lang.common_txt201
      } else if (v === 'bet$s_cancelled') {
        return this.$lang.common_txt202
      } else if (v === 'bet$draw_waiting') {
        return this.$lang.common_txt203
      }
    },
    goToDetil(v = {}) {
      if (!this.hasLogin()) {
        this.showNeedLogin()
        return
      }
      if (this.readOnlyQuery || this.readFailed) {
        this.showReadBlocked()
        return
      }
      if (!v.betOrderNo && !v.childOrderNo) return
      if (typeof this.$jumpTo === 'function') {
        this.$jumpTo('/bettingDetails', {
          mainOrderNo: v.betOrderNo,
          childOrderNo: v.childOrderNo
        })
      }
    },
    async selectType(i) {
      this.loading = false // 是否正在加载更多数据
      this.finished = false // 是否已经加载完所有数据
      // this.isRefreshing = false // 是否正在下拉刷新
      await this.GetBetList({ selectIndex: i, reset: true })
    },
    async GetBetList(options) {
      const requestOptions = options || {}
      const reset = requestOptions.reset === true
      const targetSelectIndex = requestOptions.selectIndex === undefined
        ? this.selectIndex
        : requestOptions.selectIndex
      const targetPageIndex = reset ? 0 : this.pageIndex
      if (!this.hasLogin()) {
        this.loading = false
        this.finished = true
        this.readFailed = true
        this.readOnlyMessage = this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
        this.showNeedLogin()
        return false
      }
      this.loading = true
      try {
        const data = await GetBetList({
          betGameType: 'TT_LOTTERY',
          hisType: targetSelectIndex === 0 ? 'n_won' : 'n_draw_waiting',
          pageIndex: targetPageIndex,
          pageSize: this.pageSize,
          queryType: 'three_month'
        })
        this.readOnlyQuery = isLotteryReadOnlyQueryResponse(data)
        this.readFailed = false
        if (isLotteryNeedLoginResponse(data)) {
          this.finished = true
          this.readFailed = true
          this.readOnlyMessage = lotteryResponseMessage(
            data,
            this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
          )
          this.showNeedLogin()
        } else if (isLotteryReadableResponse(data)) {
          this.readOnlyMessage = ''
          const list = this.pickList(data, [
            'betList',
            'list',
            'dataList',
            'orderList',
            'records',
            'items',
            'pageList'
          ]).map(this.normalizeBet)
          if (reset && !list.length && this.betList.length && this.readOnlyQuery) {
            this.finished = true
            this.readFailed = true
            this.readOnlyMessage = lotteryResponseMessage(
              data,
              this.$lang.common_txt376 || this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
            )
            if (typeof this.$toast === 'function') {
              this.$toast({
                message: this.readOnlyMessage,
                icon: 'cross'
              })
            }
            return false
          }
          if (reset && list.length) {
            this.selectIndex = targetSelectIndex
            this.pageIndex = 0
            this.betList = []
          } else if (reset) {
            this.selectIndex = targetSelectIndex
            this.pageIndex = 0
          }

          // 如果没有新数据，表示加载完成
          if (list.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          this.mergeBetList(list)
          // this.isRefreshing = false
          // 加载下一页
          this.pageIndex++
          return true
        } else {
          this.finished = true
          this.readFailed = true
          this.readOnlyMessage = lotteryResponseMessage(data, this.$lang.noempt)
          if (typeof this.$toast === 'function') {
            this.$toast({
              message: this.readOnlyMessage,
              icon: 'cross'
            })
          }
        }
      } catch (error) {
        this.finished = true
        this.readFailed = true
        const payload = this.responseErrorPayload(error)
        if (isLotteryNeedLoginResponse(payload)) {
          this.readOnlyMessage = lotteryResponseMessage(
            payload,
            this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
          )
          this.showNeedLogin()
          return false
        }
        this.readOnlyMessage = lotteryResponseMessage(
          payload,
          this.$lang.common_txt376 || this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
        )
        if (typeof this.$toast === 'function') {
          this.$toast({
            message: this.readOnlyMessage,
            icon: 'cross'
          })
        }
      } finally {
        // 加载状态结束
        this.loading = false
      }
      return false
    },
    // 加载更多数据
    loadMore() {
      return this.GetBetList()
    }
    // // 下拉刷新
    // handleRefresh() {
    //   this.isRefreshing = true
    //   this.pageIndex = 0
    //   this.finished = false
    //   this.betList = []
    //   this.loadMore()
    // }
  }
}
</script>
<style lang="less" scoped>
.bet-bg {
  background: #f3f5f9;
  text-align: center;
  font-size: var(--vk-fs-15);
  font-weight: bold;
  color: @title-color;
  padding: 8px 60px 0;
  line-height: 35px;
  position: sticky;
  top: 0;
}
.active-type {
  color: #3979e3;
  border-bottom: 2px solid #3979e3;
}
// .bet-scroll {
//   width: 100%;
//   padding: 3%;
//   overflow-y: auto; /* 垂直方向可滚动 */
//   height: 86vh;
// }
.order-list {
  width: 100%;
  padding: 3%;
  overflow-y: auto; /* 垂直方向可滚动 */
  height: 86vh;
  background: #f3f5f9;
}
.lot-readonly-message {
  margin: 10px 3% 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff7e6;
  color: #9a5b00;
  font-size: var(--vk-fs-sm);
  line-height: 1.4;
}
.bet-scroll-i {
  background: #ffffff;
  border-radius: 13px;
  padding: 15px 10px;
  margin-bottom: 10px;
  color: #000000;
}
::v-deep .van-loading {
  padding-top: 0%;
  background: transparent;
}
::v-deep .van-nav-bar__content {
  background: #ffffff !important;
  color: #000000 !important;
}
::v-deep .van-nav-bar__title {
  color: #000000 !important;
}
::v-deep .van-icon-arrow-left {
  color: #000000 !important;
}
.empt-bg {
  height: 78vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  color: #7c8d8f;
}
::v-deep .van-nav-bar {
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1) !important;
}
</style>
